import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=4e1a5afe&"
import script from "./GalleryList.vue?vue&type=script&lang=ts&"
export * from "./GalleryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports